import { serviceNumberTypeConstants } from '../constants';

export function servicenumbertype(state = {}, action) {
  switch (action.type) {
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPE_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPE_SUCCESS:
      return {
        ...state, servicenumbertype: action.data
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPE_FAILURE:
      return {
        error: action.error
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_SUCCESS:
      return {
        ...state, servicenumbertypes: action.data
      }
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_FAILURE:
      return {
        error: action.error
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_SUCCESS:
      return {
        ...state, servicenumbertypecoverage: action.data
      }
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_FAILURE:
      return {
        error: action.error
      };

    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_SUCCESS:
      return {
        ...state, servicenumbertypecoveragecoordinates: action.data
      }
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_FAILURE:
      return {
        error: action.error
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_SUCCESS:
      return {
        ...state, servicenumbertypecoveragecities: action.data
      }
    case serviceNumberTypeConstants.GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_FAILURE:
      return {
        error: action.error
      };

    case serviceNumberTypeConstants.UPLOAD_FILE_SERVICE_NUMBER_TYPE_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.UPLOAD_FILE_SERVICE_NUMBER_TYPE_SUCCESS:
      return {
        ...state
      };
    case serviceNumberTypeConstants.UPLOAD_FILE_SERVICE_NUMBER_TYPE_FAILURE:
      return {
        uploaderror: action.error
      };
    case serviceNumberTypeConstants.ADD_SERVICE_NUMBER_TYPE_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.ADD_SERVICE_NUMBER_TYPE_SUCCESS:
      return {
        ...state
      };
    case serviceNumberTypeConstants.ADD_SERVICE_NUMBER_TYPE_FAILURE:
      return {
        error: action.error
      };
    case serviceNumberTypeConstants.ADD_BULK_SERVICE_NUMBER_TYPE_REQUEST:
      return {
        bulkloading: true
      };
    case serviceNumberTypeConstants.ADD_BULK_SERVICE_NUMBER_TYPE_SUCCESS:
      return {
        ...state, bulkresults: action.data.data, bulkloading: undefined
      };
    case serviceNumberTypeConstants.ADD_BULK_SERVICE_NUMBER_TYPE_FAILURE:
      return {
        error: action.error
      };
    case serviceNumberTypeConstants.UPDATE_SERVICE_NUMBER_TYPE_REQUEST:
      return {
        loading: true
      };
    case serviceNumberTypeConstants.UPDATE_SERVICE_NUMBER_TYPE_SUCCESS:
      return {
        ...state
      };
    case serviceNumberTypeConstants.UPDATE_SERVICE_NUMBER_TYPE_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
